import { SearchEngineTypeValue, SearchType } from 'modules/shared/models/screening.models';
import { PostScreeningPayload } from 'store/models/screening.models';

export interface SearchPushMessage {
  // BE is using inconsistent name for internet search
  // engine_type: SearchEngineTypeValue;
  engine_type: any;
  err: string;
  search_type: string;
  record_id?: number;
  base_url?: PusherMessageBaseUrlObject;
  extra_data?: PusherMessageExtraDataObject;
}

export interface OriginalPusherMessage {
  engine_type: SearchEngineTypeValue;
  err: string;
  extra_data: string;
  search_type: SearchType;
  base_url?: string;   // for screening only
  record_id?: number;  // for quickscan only
}

export interface PusherMessageBaseUrlObject {
  customerId: number;
  crpId: number;
  primaryCrp: boolean;
  recordId: number;
  generateReport: SearchPushEvent;
}

export interface PusherMessageExtraDataObject {
  uuid: string;
}

// For Screening
export interface SearchPusher {
  customerId: number;
  crpId?: number;
  id: number;
  engineType: SearchEngineTypeValue;
  isRemoved?: boolean;
  error?: boolean;
  generateReport?: SearchPushEvent;
}

export interface CustomerPusher {
  id: number;
  name: string;
  error?: boolean;
  screeningRequest: PostScreeningPayload;
  isRemoved?: boolean;
}

export enum SearchPushEvent {
  GENERATE_REPORT = 'GENERATE_REPORT',
  NO_GENERATE_REPORT = 'NO_GENERATE_REPORT'
}

export interface PushSearchDoneEvent {
  customerId: number;
  customerName?: string;
}

// For Quickscan
export interface QuickscanPusher {
  id: string;
  name: string;
}

export interface QuickscanSearchPusher {
  id: string;
  engineType: SearchEngineTypeValue;
  isRemoved?: boolean;
}

export interface PushQuickScanSearchDoneEvent {
  quickscanId: number;
  engineType: SearchEngineTypeValue;
}

// For nlp
export interface NlpPusher {
  customerId?: number;
  crpId?: number;
  recordId?: number;
  isRemoved?: boolean;
  error?: boolean;
}

export interface QuickscanNlpPusher {
  isRemoved?: boolean;
  error?: boolean;
  id: string;
}
